<template>
  <div>
    <b-table-simple>
      <b-thead  hover borderless striped small class="tablehead">
        <b-tr>
          <b-th v-for="field in fields" :key="field.key" 
                :class="[{ 'tablenamecol': field.key === 'Name' }, { 'tablecellcol': field.key !== 'Name'}]"
                :colspan="field.colspan">
                {{ field.label }}                
          </b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <b-tr  v-for="kpi in items" :key="kpi.key" >
          <b-td class="tablenamecol" colspan="4">{{ kpi.Name }}</b-td>
          <b-td class="tablecellcol">{{ kpi.Wave0 }}</b-td>
          <b-td class="tablecellcol">{{ kpi.Wave1 }}</b-td>
          <b-td class="tablecellcol">{{ kpi.Wave2 }}</b-td>
          <b-td class="tablecellcol">{{ kpi.Wave3 }}</b-td>
          <b-td class="tablecellcol">{{ kpi.YTDitems }}</b-td>
          <b-td class="tablecellcol">{{ kpi.YTDscore }}</b-td>
          <b-td class="tablecellcol">{{ kpi.last }}</b-td>
        </b-tr>
      </b-tbody>
      <b-tfoot class="tablehead">
        <b-tr>
          <b-td class="tablenamecol" colspan="4">{{ foot.Name }}</b-td>
          <b-td class="tablecellcol" :class="{ 'waveGreen': foot.Class0 === 'g', 'waveRed': foot.Class0 === 'r' }">{{ foot.Wave0 }}</b-td>
          <b-td class="tablecellcol" :class="{ 'waveGreen': foot.Class1 === 'g', 'waveRed': foot.Class1 === 'r' }">{{ foot.Wave1 }}</b-td>
          <b-td class="tablecellcol" :class="{ 'waveGreen': foot.Class2 === 'g', 'waveRed': foot.Class2 === 'r' }">{{ foot.Wave2 }}</b-td>
          <b-td class="tablecellcol" :class="{ 'waveGreen': foot.Class3 === 'g', 'waveRed': foot.Class3 === 'r' }">{{ foot.Wave3 }}</b-td>
          <b-td class="tablecellcol">{{ foot.YTDitems }}</b-td>
          <b-td class="tablecellcol">{{ foot.YTDscore }}</b-td>
          <b-td class="tablecellcol">{{ foot.last }}</b-td>
        </b-tr>
      </b-tfoot>
    </b-table-simple>
  </div>
</template>

<script>
export default {
  props: {
    kpis: { type: Array, default: () => undefined}
  },

  data() {
    return {
      fields: [],
      items: [],
      foot: {}
    };
  },

  mounted() {
    this.fields = this.initializeFields(this.kpis);
    this.items = this.initializeItems(this.kpis);
    this.foot = this.initializeFooter(this.kpis[this.kpis.length - 1]);
  },

  methods: {
    initializeFields(kpis) {
      let fields = [
        { key: 'Name', label: '', colspan: 4, sortable: false }
      ];
      if (!Array.isArray(kpis) || !Array.isArray(kpis[0].SurveyWave)) 
        return fields;

      // get all waves
      for (const [i, value] of kpis[0].SurveyWave.entries()) {
        fields.push({ key: `Wave${i}`, label: value.Name, colspan: 1 });
      }

      // Get YTD, YTD-Score and Last Check Result
      fields.push({ key: `YTDitems`, label: this.$t('Webportal.Dashboard.Improvements.YtdHeader') });
      fields.push({ key: `YTDscore`, label: this.$t('Webportal.Dashboard.Improvements.YtdScore') });
      fields.push({ key: `last`, label: this.$t('Webportal.Dashboard.Improvements.LastCheckResult') });

      return fields;
    },

    initializeItems(kpis) {
      let items = [];
      if (!Array.isArray(kpis)) 
        return items;

      // get all waves
      for (const [i, kpi] of kpis.entries()) { 
        let item = {};
        try {
          item.Name = kpi.KpiName;
          item.YTDscore = `${Math.round(kpi.YTD.Result * 100)}%`;
        } catch (error) {
          console.error(kpi);
        }

        if (kpis.length - 1 > i) {
          // get wave text
          for (const [j, wave] of kpi.SurveyWave.entries()) {
            item[`Wave${j}`] = this.getResultText(wave);
          }
            
          item.last = `${Math.round(kpi.SurveyWave.map(x => x.Result).filter(x => x !== undefined).pop() * 100)}%`;
          
          // Get YTD compressed
          let failed = kpi.SurveyWave.filter(x => x.HasPassed === false).length;
          let improved = kpi.SurveyWave.filter(x => x.HasImproved === true).length
          let passed = kpi.SurveyWave.filter(x => x.HasPassed === true).length
          item.YTDitems = `${failed} / ${improved} / ${passed}`;
          items.push(item);
        }
      }
      return items;
    },

    initializeFooter(kpi) {
      let item = {};
      try {
        item.Name = kpi.KpiName;
        item.YTDscore = `${Math.round(kpi.YTD.Result * 100)}%`;
      } catch (error) {
        console.error(kpi);
      }

      for (const [j, wave] of kpi.SurveyWave.entries()) {
        if (wave.Passed || wave.Failed) {
          item[`Wave${j}`] = `${wave.Passed} / ${wave.Failed + wave.Passed}`;
          item[`Class${j}`] = wave.HasBonus ? 'g' : 'r';
        } else {
          item[`Wave${j}`] = ``;
        }
      }

      // Get YTD compressed
      item.YTDitems = `${kpi.YTD.Failed} / ${kpi.YTD.Improved} / ${kpi.YTD.Passed}`;
      item.YTDscore = `${Math.round(kpi.YTD.Result * 100)}%`;
      item.last = `${Math.round(kpi.LastWave.Result * 100)}%`;

      return item;
    },

    getResultText(item) {
      return item.HasImproved ? 'improved' :
        item.HasPassed == true ? 'passed' :
        item.HasPassed == false ? 'failed' : '';
    }
  }
}
</script>

<style lang="scss" scoped>
@import  "@/../scss/bmw/variables.scss";

.tablenamecol {
  text-align: right;
}

.tablecellcol {
  text-align: center;
}

.tablehead {
  background-color: $bmw-2021-bg-verylight;
  color: $bmw-2021-fg-inv; 
  font-weight: 600;
}

.waveGreen {
  background-color: $bmw-green;
}

.waveRed {
  background-color: $bmw-red;
}
</style>